module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 021.3ec81c30.jpg";